"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorDetail = getErrorDetail;
var _is = require("../utils/is");
/**
 * @Author: Alexander Silva Barbosa
 * @Date:   2023-02-08 10:26:53
 * @Last Modified by:   Alexander Silva Barbosa
 * @Last Modified time: 2023-02-08 10:35:49
 */

function getErrorDetail(o) {
  if ((0, _is.isArray)(o)) {
    let detail = '';
    for (let i = 0; i < o.length; i++) {
      detail += o[i].msg;
      if (o[i].loc) {
        detail += ' "';
        for (let j = 0; j < o[i].loc.length; j++) {
          detail += o[i].loc[j];
          if (j < o[i].loc.length - 1) detail += "/";
        }
        detail += '"';
      }
      if (i < o.length - 1) detail += ", ";
    }
    return detail;
  }
  return o;
}